import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Post from 'flarum/forum/components/Post';

app.initializers.add('atum-signature', () => {
  extend(Post.prototype, 'oncreate', function () {
    const user = this.attrs.post.user();
    if (!user) return;

    const isAdmin = user.groups().some(g => g.nameSingular() === 'Admin');
    const isMod   = user.groups().some(g => g.nameSingular() === 'Mod');

    if (isAdmin || isMod) {
      const $content = this.element.querySelector('.Post-body');
      if ($content && !$content.querySelector('.AtumSignature')) {
        const url = app.forum.attribute('baseUrl') + '/atum-signature/signature.html?t=' + Date.now();
        fetch(url)
          .then(res => res.text())
          .then(html => {
            $content.insertAdjacentHTML(
              'beforeend',
              `<div class="AtumSignature" style="margin-top:1rem; border-top:1px solid #ccc; padding-top:0.5rem; font-size:0.9em;">${html}</div>`
            );
          })
          .catch(err => console.error('Error cargando signature.html:', err));
      }
    }
  });
});
